<div class="suggested-path" *ngIf="hasPath">
  <p class="suggested-path__root-cause" *ngIf="path?.rootCause">{{ path?.rootCause }}</p>

  <ng-container *ngIf="steps.length">
    <span class="suggested-path__heading">{{ heading }}</span>

    <div class="suggested-path__step" *ngFor="let step of visibleSteps; trackBy: trackByOrder">
      <span class="suggested-path__marker" aria-hidden="true">{{ step.order }}</span>
      <div class="suggested-path__step-body">
        <span class="suggested-path__step-text">{{ step.text }}</span>
        <span class="suggested-path__step-note">{{ step.note }}</span>
      </div>
    </div>

    <button *ngIf="hasMoreSteps" type="button" class="suggested-path__next" (click)="revealNextStep()">
      {{ nextStepLabel }}
      <svg-icon src="assets/icons/arrow-down.svg" class="suggested-path__next-icon" aria-hidden="true"></svg-icon>
    </button>
  </ng-container>
</div>
